var _path, _path2, _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManufacturebig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1017C25 14.9829 23.2465 18.552 21.3333 22.4746C18.8085 27.6513 15.788 33.0165 14 34C12.1659 32.6548 9.2133 27.6979 6.66667 22.4746C4.84955 18.7475 3 14.8848 3 12.1017C3 5.41811 7.92487 0 14 0C20.0751 0 25 5.41811 25 12.1017Z",
    fill: "#254E9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.1017C25 14.9829 23.2465 18.552 21.3333 22.4746C18.8085 27.6513 15.788 33.0165 14 34C12.1659 32.6548 9.2133 27.6979 6.66667 22.4746C4.84955 18.7475 3 14.8848 3 12.1017C3 5.41811 7.92487 0 14 0C20.0751 0 25 5.41811 25 12.1017Z",
    fill: "#254E9C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "white",
    stroke: "#254E9C",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1229_272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.58 19.5226H19.5675V13.6955V11.8775C19.5675 11.6453 19.3794 11.4575 19.1475 11.4575H18.7936V8.0577C18.7936 7.82558 18.6054 7.6377 18.3736 7.6377H16.5071C16.2753 7.6377 16.0871 7.82558 16.0871 8.0577V11.4575H15.9004V8.0577C15.9004 7.82558 15.7122 7.6377 15.4804 7.6377H13.6136C13.3818 7.6377 13.1936 7.82558 13.1936 8.0577V11.4575H8.85248C8.62064 11.4575 8.43248 11.6453 8.43248 11.8775V13.6955V19.5226H7.42C7.18816 19.5226 7 19.7105 7 19.9426C7 20.1747 7.18816 20.3626 7.42 20.3626H20.58C20.8118 20.3626 21 20.1747 21 19.9426C21 19.7105 20.8118 19.5226 20.58 19.5226ZM17.9536 8.4777V8.93718H16.9271V8.4777H17.9536ZM16.9271 9.77718H17.9536V11.4575H16.9271V9.77718ZM15.0604 8.4777V8.93718H14.0336V8.4777H15.0604ZM14.0336 9.77718H15.0604V11.4575H14.0336V9.77718ZM9.27248 13.6955H18.7275V19.5226H13.1396V15.9489C13.1396 15.7168 12.9514 15.5289 12.7196 15.5289H10.7232C10.4913 15.5289 10.3032 15.7168 10.3032 15.9489V19.5226H9.27248V13.6955Z",
    fill: "#254E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.618 16.3688H17.0484C17.2802 16.3688 17.4684 16.1809 17.4684 15.9488C17.4684 15.7167 17.2802 15.5288 17.0484 15.5288H14.618C14.3862 15.5288 14.198 15.7167 14.198 15.9488C14.198 16.1809 14.3862 16.3688 14.618 16.3688Z",
    fill: "#254E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.618 17.548H17.0484C17.2802 17.548 17.4684 17.3601 17.4684 17.128C17.4684 16.8959 17.2802 16.708 17.0484 16.708H14.618C14.3862 16.708 14.198 16.8959 14.198 17.128C14.198 17.3598 14.3862 17.548 14.618 17.548Z",
    fill: "#254E9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.618 18.7272H17.0484C17.2802 18.7272 17.4684 18.5393 17.4684 18.3072C17.4684 18.0751 17.2802 17.8872 17.0484 17.8872H14.618C14.3862 17.8872 14.198 18.0751 14.198 18.3072C14.198 18.5393 14.3862 18.7272 14.618 18.7272Z",
    fill: "#254E9C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1229_272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManufacturebig);
export default __webpack_public_path__ + "static/media/manufacture big.12a1ebae8176941fe649013b40ed3a02.svg";
export { ForwardRef as ReactComponent };